<template>
  <full-container v-loading="loading">
    <!--工具条-->
    <div slot="header" class="toolbar">
      <ul class="tabs">
        <li
          v-for="(item, index) in typeOptions"
          :key="index"
          :class="{ selected: queryParams.type == item.value }"
          @click="
            queryParams.type = item.value
            onSearch()
          "
        >
          {{ item.text }}
        </li>
      </ul>

      <el-form ref="ff" size="small" :inline="true" :model="queryParams" class="search-form">
        <el-form-item>
          <el-select v-model="queryParams.categorys" multiple collapse-tags clearable placeholder="品类筛选" style="width: 160px">
            <el-option v-for="(item, index) in categoryOptions" :key="index" :label="item" :value="item" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input v-model="queryParams.keyWord" clearable placeholder="编号/规格" style="width: 160px" />
        </el-form-item>
        <el-form-item>
          <el-input v-model="queryParams.usability" clearable placeholder="适用机型" style="width: 160px" />
        </el-form-item>
        <el-form-item>
          <el-button-group>
            <el-button type="primary" @click="onSearch">查询</el-button>
            <el-button @click="resetForm">重置</el-button>
          </el-button-group>
        </el-form-item>
      </el-form>
    </div>
    <!--表格-->
    <el-table :data="datalist.Items" height="100%">
      <el-table-column label="类别" min-width="100" show-overflow-tooltip>
        <template slot-scope="{ row }">
          <el-tag size="mini" v-if="row.Type == '原装'" type="danger" effect="dark">{{ row.Type }}</el-tag>
          <el-tag size="mini" v-else>{{ row.Type }}</el-tag>
          {{ row.Category }}
        </template>
      </el-table-column>
      <el-table-column prop="Brand" label="品牌" min-width="100" show-overflow-tooltip />
      <el-table-column prop="Code" label="编号" min-width="100" show-overflow-tooltip />
      <el-table-column prop="Spec" label="规格" min-width="150" show-overflow-tooltip />
      <el-table-column prop="Usability" label="适用机型" min-width="200" show-overflow-tooltip />
      <el-table-column prop="Weight" label="重量" min-width="60" show-overflow-tooltip />
      <el-table-column prop="Lifetime" label="使用寿命" min-width="60" show-overflow-tooltip />
      <el-table-column prop="Price" label="批发价格" min-width="60">
        <template slot-scope="{ row }">
          <el-tooltip v-if="Object.keys(row).includes('Price')" placement="right" :disabled="!row.Remarks">
            <div slot="content" style="max-width: 400px">{{ row.Remarks }}</div>
            <span class="text-price text-danger">{{ row.Price }}</span>
          </el-tooltip>
          <template v-else>—</template>
        </template>
      </el-table-column>
      <el-table-column label="库存编码" width="160">
        <template slot-scope="{ row }">
          <el-link type="primary" @click="$router.push({ name: 'a137ea3f52d84685b74168439cf660c9', params: { tenant: 1, code: row.StockCode1 } })">{{ row.StockCode1 }}</el-link>
          <el-link type="primary" @click="$router.push({ name: 'a137ea3f52d84685b74168439cf660c9', params: { tenant: 2, code: row.StockCode2 } })">{{ row.StockCode2 }}</el-link>
        </template>
      </el-table-column>
    </el-table>

    <!--分页-->
    <div slot="footer" class="toolbar">
      <el-button v-action="'/api/ProductManage/Material/Import'" size="small" type="primary" icon="el-icon-upload" @click="importData">导入</el-button>
      <el-pagination background :page-size="datalist.PageSize" :current-page="datalist.PageIndex" :total="datalist.TotalCount" @current-change="onPager" />
    </div>
  </full-container>
</template>

<script>
import importpage from './import.vue'
export default {
  data () {
    return {
      loading: false,
      typeOptions: [],
      categoryOptions: [],
      datalist: [],
      queryParams: {
        index: 1,
        size: 30,
        categorys: [],
        type: null
      },
    }
  },
  created () {
    this.loadData()
    this.$apis.product.material.types().then(res => {
      this.typeOptions = res.map(row => {
        return { text: row, value: row }
      })
      this.typeOptions.unshift({ text: '全部', value: null })
      return this.$apis.product.material.categorys()
    }).then(res => {
      this.categoryOptions = res
    })
  },
  methods: {
    // 查询参数
    onSearch () {
      this.queryParams.index = 1
      this.loadData()
    },
    resetForm () {
      this.queryParams = {
        index: 1, size: 20, types: [],
        categorys: []
      }
      this.loadData()
    },
    // 分页触发事件
    onPager (val) {
      this.queryParams.index = val
      this.loadData()
    },
    // 信息列表
    loadData () {
      if (this.loading) {
        return
      }
      this.loading = true
      this.$apis.product.material.list(this.queryParams).then((res) => {
        this.datalist = res
      }).catch((e) => {
        this.$message.error(e)
      }).finally(() => {
        this.loading = false
      })
    },
    //导入数据
    importData () {
      this.$layer.iframe({
        title: '导入数据',
        area: ['1000px', '800px'],
        content: {
          content: importpage,
          parent: this,
          data: {
            callback: () => {
              this.loadData()
            }
          }
        }
      })
    }
  }
}
</script>


<style lang="scss" scoped>
ul.tabs {
  display: flex;
  padding: 0 16px;
  li {
    list-style: none;
    padding: 5px 0;
    position: relative;
    cursor: pointer;
  }
  li + li {
    margin-left: 20px;
  }
  li.selected {
    color: #409eff;
  }
  li.selected::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    height: 3px;
    width: 100%;
    background: #409eff;
  }
}
</style>